<div class="row main-header" 
     [class.has-bg-image]="hasThemeBackground"
     [ngStyle]="getHeaderStyle()">
    <div class="col-sm-6">
        <div class="row">
            <div class="col-sm-3">
                <a href="/home"><img src="../../../assets/images/gentari_logo.svg" alt="" srcset="" class="logo"></a>
            </div>
            <div class="col-sm-9 text-part">
                <p>Gentari Empower | <span class="light">Your Employee Experience Portal</span></p>
            </div>
        </div>

    </div>
    <div class="col-sm-6 user-img-section">
        <div class="mainNameSection">
            <span *ngIf="showText" class="round" id="round"> {{initials}}</span>
            <span class="name">{{fullName}}</span>
            <span *ngIf="!showText" class="round" id="roundImg">
                <img [src]="imageSrc" alt="" style="width: 100%; border-radius: 50%;" />
            </span>
        </div>
    </div>
</div>